import { fg } from '@confluence/feature-gating';

import { useAIAgentIssuesStreaming } from '../hooks/useAIAgentIssuesStreaming';
import { useConvoAIIssuesStreaming } from '../hooks/useConvoAIIssuesStreaming';

export const useAIAgentStreamingData = () => {
	const { aiAgentContent, aiAgentCurrentAiState, aiAgentResponseState } = useAIAgentIssuesStreaming(
		fg('confluence_ai_bulk_issue_convo_ai_migration'),
	);
	const { convoAIContent, convoAICurrentAiState, convoAIResponseState } = useConvoAIIssuesStreaming(
		fg('confluence_ai_bulk_issue_convo_ai_migration'),
	);

	if (fg('confluence_ai_bulk_issue_convo_ai_migration')) {
		return {
			content: convoAIContent,
			currentAiState: convoAICurrentAiState,
			responseState: convoAIResponseState,
		};
	}

	return {
		content: aiAgentContent,
		currentAiState: aiAgentCurrentAiState,
		responseState: aiAgentResponseState,
	};
};
